import React, { HTMLProps, useEffect, useState } from 'react';

import cn from 'classnames';

import useToken from '@/hooks/token';
import { useTranslate } from '@/hooks/use-translate';
import { useApplicationNavigationStore } from '@/store/zustand/application-navigation-store';
import { Storage } from '@/types/storage';

import { EnabledElement } from './EnabledElement/EnabledElement';
import { en } from './en';
import {
	AddFishIcon,
	BargainIcon,
	ServiceIcon,
	ShipmentIcon,
	StorageIcon,
	TransferIcon,
} from './icons';
import { RouteData } from './types';

import styles from './NewApplicationFork.module.scss';

type NewApplicationForkProps = HTMLProps<HTMLDivElement> & {
	storage?: Storage;
	serviceApplicationDisable?: boolean;
};

export default function NewApplicationFork(props: NewApplicationForkProps) {
	const { storage, serviceApplicationDisable, className } = props;

	const token = useToken();
	const t = useTranslate(en);
	const [authed, setAuthed] = useState<boolean>();

	const setStartPage = useApplicationNavigationStore((state) => state.setStartPage);

	useEffect(() => {
		setAuthed(token != null && token !== '');
	}, [token]);

	const storageQuery = storage ? `?warehouseId=${storage.id}` : '';
	const storageQueryLegacy = storage ? `?name=${storage.title}` : '';

	const routeData: RouteData[] = [
		{
			name: t('На добавление'),
			path: `/applications/add-products${storageQuery}`,
			description: 'Завести на платформу продукцию, уже размещенную на складе',
			icon: <AddFishIcon />,
		},
		{
			name: t('На хранение'),
			description: 'Отправить складу запрос на размещение продукции',
			path: `/applications/storage-application${storageQuery}`,
			icon: <StorageIcon />,
		},
		!storage?.virtual && {
			name: t('На передачу'),
			description: 'Передать продукцию новому собственнику внутри склада',
			path: `/applications/transfer-application${storageQuery}`,
			icon: <TransferIcon />,
		},
		{
			name: t('На отгрузку'),
			description: 'Отгрузить продукцию со склада в адрес нового собственника',
			path: `/applications/shipment-application${storageQueryLegacy}`,
			icon: <ShipmentIcon />,
		},
		{
			name: t('На договор'),
			description: 'Заключить договор хранения со складом',
			path: `/applications/agreement-application${storageQuery}`,
			icon: <BargainIcon />,
		},
		!storage?.virtual && {
			name: t('На доп. услуги'),
			description: 'Запросить дополнительные услуги у склада',
			path: `/applications/service-application${storageQueryLegacy}`,
			icon: <ServiceIcon />,
		},
	].filter(Boolean);

	return (
		<div className={cn(styles.newAppFork, className)}>
			{routeData.map((route) => (
				<div
					key={route.path}
					onClick={() => setStartPage(window.location.pathname)}
					className={cn(styles.newAppForkPlate, {
						[styles.newAppForkDisable]:
							serviceApplicationDisable && route.path === '/applications/service-application',
					})}
				>
					<EnabledElement route={route} authed={authed} />
				</div>
			))}
		</div>
	);
}
